import { useOidc } from "@axa-fr/react-oidc";
import React from "react";
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardBody, CardTitle } from 'reactstrap';
import { NavigationCardData } from "./NavigationCardSet";

interface Props {
    cardData: NavigationCardData
}

export const NavigationCard = (props: Props) => {
    const navigate = useNavigate();
    const { isAuthenticated } = useOidc();

    return (
        <Card className="navCard" onClick={() => {
            if (isAuthenticated) {
                navigate(props.cardData.fieldCardLink);
            } else {
                navigate('/Login');
            }
        }}>
            <CardTitle className="cardTitle">
                <div dangerouslySetInnerHTML={{ __html: props.cardData.fieldCardTitle }} />
                <div className="navButton">
                    {isAuthenticated ? (
                        <Button className="submitButton hollowNeg tertiaryButton iconRightArrow">Learn more</Button>
                    ) : (
                        <Button className="submitButton hollowNeg tertiaryButton iconRightArrow">Get Access</Button>
                    )}
                </div>
            </CardTitle>
            <CardBody className="cardBody flexible">
                {props.cardData.fieldCardImage ? (
                    <div className={'cardBodyImageContainer'}>
                        <img className="cardBodyImage" src={props.cardData.fieldCardImage.url} alt={props.cardData.fieldCardImage.alt} title={props.cardData.fieldCardImage.title} />
                    </div>
                ) : (
                        <div className="cardBodyText" dangerouslySetInnerHTML={{ __html: props.cardData.fieldCardContent }} />
                )}
            </CardBody>
        </Card>
    )
}
